import Dropdown from "react-bootstrap/Dropdown";

export default function LocationDropdown({
  locations,
  selectedLocation,
  setSelectedLocation,
}) {
  const handleLocationChange = (locationId) => {
    setSelectedLocation(locationId);
  };

  return (
    <Dropdown className='location-selector border-start p-2'>
      <Dropdown.Toggle
        variant='outline-secondary'
        style={{
          minWidth: "220px",
          backgroundColor: "#fff",
          border: "1px solid #ced4da",
          color: "#212529",
          boxShadow: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          textAlign: "left",
        }}
        id='locationDropdown'
      >
        {selectedLocation === "All"
          ? "All Locations"
          : locations?.find(
              (location) => location.locationId === selectedLocation
            )?.name || "Select Locations"}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => handleLocationChange("All")}>
          All Locations
        </Dropdown.Item>
        {locations.map((location) => (
          <Dropdown.Item
            key={location.locationId}
            onClick={() => handleLocationChange(location.locationId)}
          >
            {location.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
